import styles from './HostServiceDetailPhotos.module.css'
import { useState, useEffect } from 'react'
import { useReadHostServiceByMonitorIdQuery } from 'services/hostService'
import { DateTime } from 'luxon'
import { ImageSlider2 } from 'shared/ui/strspykit/ImageSlider2'

interface HostServiceDetailPhotosProps {
    hostServiceId: number
    spyId?: number
}

export const HostServiceDetailPhotos = (props: HostServiceDetailPhotosProps): JSX.Element => {
    const {
        hostServiceId = -1,
        spyId = -1
    } = props

    const [images, setImages] = useState<any>([])

    const readMonitorRunResultByMonitorIdQueryOptions = {
        refetchOnMountOrArgChange: true,
    }

    const readHostServiceByMonitorIdQueryParams = {
        monitorId: spyId,
        hostServiceId: hostServiceId,
        firstDay: DateTime.fromMillis(0).toSQLDate() || '',
        lastDay: DateTime.fromMillis(0).toSQLDate() || '',
    }

    const {
        data: readHostServiceByMonitorIdQueryData,
        isLoading: readHostServiceByMonitorIdQueryDataIsLoading,
        isFetching: readHostServiceByMonitorIdQueryDataIsFetching,
        error: readHostServiceByMonitorIdQueryError
    } = useReadHostServiceByMonitorIdQuery(readHostServiceByMonitorIdQueryParams, readMonitorRunResultByMonitorIdQueryOptions)

    useEffect(() => {
        if (readHostServiceByMonitorIdQueryData === undefined){
            setImages([])
            return
        }

        if (readHostServiceByMonitorIdQueryData.strHostservicePictures === undefined){
            setImages([])
            return
        }

        setImages(
            readHostServiceByMonitorIdQueryData.strHostservicePictures.map((strHostservicePicture: any) => {
                return {
                    src: strHostservicePicture.url,
                    title: strHostservicePicture.description
                }
            })
        )

    }, [
        readHostServiceByMonitorIdQueryData
    ])

    return (
        <div>
            <ImageSlider2
                className={styles.HostServiceDetailPhotos__ImageSlider}
                images={images}
            />
        </div>
    )
}
